import { render, staticRenderFns } from "./Reassign.vue?vue&type=template&id=28036c68&scoped=true"
import script from "./Reassign.vue?vue&type=script&lang=js"
export * from "./Reassign.vue?vue&type=script&lang=js"
import style0 from "./Reassign.vue?vue&type=style&index=0&id=28036c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28036c68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VForm,VListItemContent,VListItemTitle})
